import { TerminologyEditor } from '@/components/terminology/TerminologyEditor'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import type { TermProfile } from '@/api/terminologyApi'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  profile: TermProfile | null
}

/** Popup that hosts the per-locale term editor (namespace tabs + search + save). */
export function EditTermsModal({ open, onOpenChange, profile }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Edit terms — {profile?.label ?? ''}</DialogTitle>
          <DialogDescription>
            Override how terms read for this profile. Empty inputs inherit the base value
            shown beneath each key.
          </DialogDescription>
        </DialogHeader>
        {profile && <TerminologyEditor locale={profile.id} />}
      </DialogContent>
    </Dialog>
  )
}
